<div class="k-row">
    <div style="
          display:inline;
          text-align:right;
          padding-bottom: 10px;
          padding-top: 10px;" class="ng-star-inserted">
        <button
                class="k-generic-btn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
                *ngIf="activeView!=0"
                (click)="showList()"
                style="height: 40px;"
                pButton
                type="button"
                label="{{labelButtonBack}}">
        </button>
    </div>
</div>

<app-store-group-list
    *ngIf="activeView==0"
    (onShowDetails)="showGroupDetails($event)">
</app-store-group-list>

<app-store-group-details
    *ngIf="activeView!=0"
    [store_group]="storeGroup">
</app-store-group-details>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group.component.html